import { render, staticRenderFns } from "./ApparatusDetails.vue?vue&type=template&id=791b4b89&scoped=true"
import script from "./ApparatusDetails.vue?vue&type=script&lang=js"
export * from "./ApparatusDetails.vue?vue&type=script&lang=js"
import style0 from "./ApparatusDetails.vue?vue&type=style&index=0&id=791b4b89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791b4b89",
  null
  
)

export default component.exports